import React, { useEffect, useState } from 'react'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { createRoot } from 'react-dom/client'
import theme from '~/themes/theme'
import { theme as bsTheme } from 'bs-unified-ui'
import CustomDialog from './CustomDialog'
import UnifiedErrorDialog from './UnifiedErrorDialog'
import UnifiedConfirmDialog from './UnifiedConfirmDialog'

const DialogContent = (props) => {
  const [open, setOpen] = useState(true)

  useEffect(() => {
    setOpen(true)
  }, [props])

  const close = () => {
    setOpen(false)
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CustomDialog open={open} onClose={close} {...props} />
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

const UnifiedErrorDialogContent = (props) => {
  const [open, setOpen] = useState(true)

  useEffect(() => {
    setOpen(true)
  }, [props])

  const onClose = () => {
    setOpen(false)
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={bsTheme}>
        <UnifiedErrorDialog open={open} onClose={onClose} {...props} />
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

const UnifiedConfirmDialogContent = (props) => {
  const [open, setOpen] = useState(true)

  useEffect(() => {
    setOpen(true)
  }, [props])

  const onClose = () => {
    setOpen(false)
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={bsTheme}>
        <UnifiedConfirmDialog open={open} onClose={onClose} {...props} />
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

const showDialog = (props) => {
  const root = createRoot(document.getElementById('errorMessage'))
  root.render(<DialogContent {...props} />)
}

const showErrorDialog = (props) => {
  const root = createRoot(document.getElementById('errorMessage'))
  root.render(<UnifiedErrorDialogContent {...props} />)
}

const showConfirmDialog = (props) => {
  const root = createRoot(document.getElementById('errorMessage'))
  root.render(<UnifiedConfirmDialogContent {...props} />)
}

export { showDialog, showErrorDialog, showConfirmDialog }
